var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "100", height: "49", viewBox: "0 0 100 49", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "no-minimums-icon"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { id: "nm_a", d: "M0 0h41v43H0z" }),
      React.createElement("path", { id: "nm_c", d: "M0 0h67v33H0z" }),
      React.createElement("path", { d: "M2.197 3.99c0-.989.791-1.79 1.773-1.79h59.06c.98 0 1.773.795 1.773 1.79v25.02a1.78 1.78 0 0 1-1.773 1.79H3.97c-.98 0-1.773-.795-1.773-1.79V3.99z", id: "nm_d" }),
      React.createElement("ellipse", { id: "nm_f", cx: "5.492", cy: "5.5", rx: "3.295", ry: "3.3" }),
      React.createElement("ellipse", { id: "nm_g", cx: "5.492", cy: "27.5", rx: "3.295", ry: "3.3" }),
      React.createElement("ellipse", { id: "nm_h", cx: "61.508", cy: "27.5", rx: "3.295", ry: "3.3" }),
      React.createElement("ellipse", { id: "nm_i", cx: "61.508", cy: "5.5", rx: "3.295", ry: "3.3" }),
      React.createElement("path", { id: "nm_j", d: "M20.288 27.232h28.558v3.3H20.288z" }),
      React.createElement("path", { id: "nm_k", d: "M19.253 5.768H47.81v3.3H19.253z" }),
      React.createElement("path", { id: "nm_l", d: "M0 0h41v43H0z" }),
      React.createElement("path", { id: "nm_n", d: "M0 0h67v33H0z" }),
      React.createElement("path", { d: "M2.197 3.99c0-.989.791-1.79 1.773-1.79h59.06c.98 0 1.773.795 1.773 1.79v25.02a1.78 1.78 0 0 1-1.773 1.79H3.97c-.98 0-1.773-.795-1.773-1.79V3.99z", id: "nm_o" }),
      React.createElement("ellipse", { id: "nm_q", cx: "5.492", cy: "5.5", rx: "3.295", ry: "3.3" }),
      React.createElement("ellipse", { id: "nm_r", cx: "5.492", cy: "27.5", rx: "3.295", ry: "3.3" }),
      React.createElement("ellipse", { id: "nm_s", cx: "61.508", cy: "27.5", rx: "3.295", ry: "3.3" }),
      React.createElement("ellipse", { id: "nm_t", cx: "61.508", cy: "5.5", rx: "3.295", ry: "3.3" }),
      React.createElement("path", { id: "nm_u", d: "M20.288 27.232h28.558v3.3H20.288z" }),
      React.createElement("path", { id: "nm_v", d: "M19.253 5.768H47.81v3.3H19.253z" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "scale(-1 1) rotate(15 -26.695 -114.726)" },
        React.createElement(
          "mask",
          { id: "nm_b", fill: "#fff" },
          React.createElement("use", { xlinkHref: "#nm_a" })
        ),
        React.createElement(
          "g",
          { mask: "url(#nm_b)" },
          React.createElement(
            "g",
            { transform: "translate(-34 5)" },
            React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_c" }),
            React.createElement("path", { stroke: "#222", d: "M.5.5h66v32H.5z" }),
            React.createElement(
              "mask",
              { id: "nm_e", fill: "#fff" },
              React.createElement("use", { xlinkHref: "#nm_d" })
            ),
            React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_d" }),
            React.createElement("path", { stroke: "#222", d: "M2.697 3.99c0-.715.57-1.29 1.273-1.29h59.06c.705 0 1.273.572 1.273 1.29v25.02c0 .715-.57 1.29-1.273 1.29H3.97a1.277 1.277 0 0 1-1.273-1.29V3.99z" }),
            React.createElement(
              "g",
              { mask: "url(#nm_e)" },
              React.createElement(
                "g",
                { transform: "translate(12.393 12.4)" },
                React.createElement("path", { d: "M2.671 6.496c-.923-.059-1.548-.407-1.754-.54-.14-.09-.12-.178-.037-.304l.327-.489c.084-.119.168-.133.298-.06.317.193.662.371 1.166.453V4.31C1.813 3.948.787 3.526.787 2.644c0-.74.644-1.37 1.884-1.466V.94c0-.082.084-.141.177-.141h.178c.093 0 .177.06.177.14v.245c.84.06 1.483.393 1.735.54.112.053.093.186.056.238l-.523.585a.199.199 0 0 1-.251.045c-.271-.156-.513-.304-1.017-.445v1.089c.811.363 1.977.726 1.977 1.733 0 .763-.746 1.437-1.977 1.526v.77c0 .075-.084.134-.177.134h-.178c-.093 0-.177-.06-.177-.133v-.77zm0-3.437v-.963c-.298.03-.532.2-.532.385 0 .267.159.4.532.578zm.532 2.519c.289-.06.504-.23.504-.46s-.178-.444-.504-.622v1.082zm36.339.918c.923-.059 1.548-.407 1.754-.54.14-.09.12-.178.037-.304l-.327-.489c-.083-.119-.167-.133-.298-.06-.317.193-.662.371-1.166.453V4.31c.858-.363 1.884-.785 1.884-1.667 0-.74-.643-1.37-1.884-1.466V.94c0-.082-.084-.141-.177-.141h-.177c-.094 0-.178.06-.178.14v.245c-.84.06-1.483.393-1.735.54-.112.053-.093.186-.056.238l.523.585a.199.199 0 0 0 .252.045c.27-.156.513-.304 1.016-.445v1.089c-.811.363-1.977.726-1.977 1.733 0 .763.746 1.437 1.977 1.526v.77c0 .075.084.134.178.134h.177c.093 0 .177-.06.177-.133v-.77zm0-3.437v-.963c.298.03.532.2.532.385 0 .267-.159.4-.532.578zm-.532 2.519c-.289-.06-.503-.23-.503-.46s.177-.444.503-.622v1.082z", fill: "#000" }),
                React.createElement("ellipse", { stroke: "#222", cx: "21.656", cy: "12.35", rx: "9.885", ry: "11.55" })
              )
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_e)" },
              React.createElement("use", { fill: "#FFF", xlinkHref: "#nm_f" }),
              React.createElement("ellipse", { stroke: "#222", cx: "5.492", cy: "5.5", rx: "2.795", ry: "2.8" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_e)" },
              React.createElement("use", { fill: "#FFF", xlinkHref: "#nm_g" }),
              React.createElement("ellipse", { stroke: "#222", cx: "5.492", cy: "27.5", rx: "2.795", ry: "2.8" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_e)" },
              React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_h" }),
              React.createElement("ellipse", { stroke: "#222", cx: "61.508", cy: "27.5", rx: "2.795", ry: "2.8" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_e)" },
              React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_i" }),
              React.createElement("ellipse", { stroke: "#222", cx: "61.508", cy: "5.5", rx: "2.795", ry: "2.8" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_e)" },
              React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_j" }),
              React.createElement("path", { stroke: "#222", d: "M20.788 27.732h27.558v2.3H20.788v-2.3z" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_e)" },
              React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_k" }),
              React.createElement("path", { stroke: "#222", d: "M19.753 6.268H47.31v2.3H19.753v-2.3z" })
            )
          )
        )
      ),
      React.createElement(
        "g",
        { transform: "rotate(15 23.171 264.044)" },
        React.createElement(
          "mask",
          { id: "nm_m", fill: "#fff" },
          React.createElement("use", { xlinkHref: "#nm_l" })
        ),
        React.createElement(
          "g",
          { mask: "url(#nm_m)" },
          React.createElement(
            "g",
            { transform: "translate(-34 5)" },
            React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_n" }),
            React.createElement("path", { stroke: "#222", d: "M.5.5h66v32H.5z" }),
            React.createElement(
              "mask",
              { id: "nm_p", fill: "#fff" },
              React.createElement("use", { xlinkHref: "#nm_o" })
            ),
            React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_o" }),
            React.createElement("path", { stroke: "#222", d: "M2.697 3.99c0-.715.57-1.29 1.273-1.29h59.06c.705 0 1.273.572 1.273 1.29v25.02c0 .715-.57 1.29-1.273 1.29H3.97a1.277 1.277 0 0 1-1.273-1.29V3.99z" }),
            React.createElement(
              "g",
              { mask: "url(#nm_p)" },
              React.createElement(
                "g",
                { transform: "translate(12.393 12.4)" },
                React.createElement("path", { d: "M2.671 6.496c-.923-.059-1.548-.407-1.754-.54-.14-.09-.12-.178-.037-.304l.327-.489c.084-.119.168-.133.298-.06.317.193.662.371 1.166.453V4.31C1.813 3.948.787 3.526.787 2.644c0-.74.644-1.37 1.884-1.466V.94c0-.082.084-.141.177-.141h.178c.093 0 .177.06.177.14v.245c.84.06 1.483.393 1.735.54.112.053.093.186.056.238l-.523.585a.199.199 0 0 1-.251.045c-.271-.156-.513-.304-1.017-.445v1.089c.811.363 1.977.726 1.977 1.733 0 .763-.746 1.437-1.977 1.526v.77c0 .075-.084.134-.177.134h-.178c-.093 0-.177-.06-.177-.133v-.77zm0-3.437v-.963c-.298.03-.532.2-.532.385 0 .267.159.4.532.578zm.532 2.519c.289-.06.504-.23.504-.46s-.178-.444-.504-.622v1.082zm35.714.918c-.923-.059-1.548-.407-1.754-.54-.14-.09-.12-.178-.037-.304l.327-.489c.083-.119.167-.133.298-.06.317.193.662.371 1.166.453V4.31c-.858-.363-1.884-.785-1.884-1.667 0-.74.643-1.37 1.884-1.466V.94c0-.082.084-.141.177-.141h.177c.094 0 .178.06.178.14v.245c.84.06 1.483.393 1.735.54.112.053.093.186.056.238l-.523.585a.199.199 0 0 1-.252.045c-.27-.156-.513-.304-1.016-.445v1.089c.811.363 1.977.726 1.977 1.733 0 .763-.746 1.437-1.977 1.526v.77c0 .075-.084.134-.178.134h-.177c-.093 0-.177-.06-.177-.133v-.77zm0-3.437v-.963c-.298.03-.532.2-.532.385 0 .267.159.4.532.578zm.532 2.519c.289-.06.503-.23.503-.46s-.177-.444-.503-.622v1.082z", fill: "#000" }),
                React.createElement("ellipse", { stroke: "#222", cx: "21.656", cy: "12.35", rx: "9.885", ry: "11.55" })
              )
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_p)" },
              React.createElement("use", { fill: "#FFF", xlinkHref: "#nm_q" }),
              React.createElement("ellipse", { stroke: "#222", cx: "5.492", cy: "5.5", rx: "2.795", ry: "2.8" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_p)" },
              React.createElement("use", { fill: "#FFF", xlinkHref: "#nm_r" }),
              React.createElement("ellipse", { stroke: "#222", cx: "5.492", cy: "27.5", rx: "2.795", ry: "2.8" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_p)" },
              React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_s" }),
              React.createElement("ellipse", { stroke: "#222", cx: "61.508", cy: "27.5", rx: "2.795", ry: "2.8" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_p)" },
              React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_t" }),
              React.createElement("ellipse", { stroke: "#222", cx: "61.508", cy: "5.5", rx: "2.795", ry: "2.8" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_p)" },
              React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_u" }),
              React.createElement("path", { stroke: "#222", d: "M20.788 27.732h27.558v2.3H20.788v-2.3z" })
            ),
            React.createElement(
              "g",
              { mask: "url(#nm_p)" },
              React.createElement("use", { fill: "#F8F8F8", xlinkHref: "#nm_v" }),
              React.createElement("path", { stroke: "#222", d: "M19.753 6.268H47.31v2.3H19.753v-2.3z" })
            )
          )
        )
      ),
      React.createElement("path", { d: "M58.024 0L45 47.44", stroke: "#222", strokeLinecap: "round", strokeLinejoin: "round" })
    )
  );
});


// WEBPACK FOOTER //
// ../public/images/icons/no-minimums.svg?react-svg